/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetPdfSettingsQueryResponse, FilesControllerGetPdfSettingsPathParams } from "../../models/filesController/FilesControllerGetPdfSettings";

function getFilesControllerGetPdfSettingsUrl(id: FilesControllerGetPdfSettingsPathParams["id"], key: FilesControllerGetPdfSettingsPathParams["key"]) {
  const res = { method: 'GET', url: `/api/v1/files/${id}/pdf-settings/${key}` as const }  
  return res
}

/**
 * @description Retrieves PDF generation settings from Redis cache by key. Returns 404 if settings have expired or key is invalid.
 * @summary Retrieve PDF generation settings
 * {@link /api/v1/files/:id/pdf-settings/:key}
 */
export async function filesControllerGetPdfSettings(id: FilesControllerGetPdfSettingsPathParams["id"], key: FilesControllerGetPdfSettingsPathParams["key"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerGetPdfSettingsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getFilesControllerGetPdfSettingsUrl(id, key).url.toString(), ... requestConfig })  
  return res.data
}